import { render } from "./Gvosiki.vue?vue&type=template&id=793356aa"
import script from "./Gvosiki.vue?vue&type=script&lang=js"
export * from "./Gvosiki.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__